import type { DraggableProvidedDragHandleProps } from '@hello-pangea/dnd'
import type { TestRankingFontSchemaType, TestRankingSchemaType } from '@vedalib/editor/lib/brand'
import React from 'react'

import Icon from 'components/uiKit/Icon'
import { KitSize } from 'components/uiKit/KitTypes'
import type { ElementFontCss, ElementStyleCss } from 'services/Branding/types'
import { testProps } from 'utils/test/qaData'

import TestRankingItemStyled from '../../styled/TestRankingItemStyled'
import * as s from './TestRankingItem.module.scss'

type TestRankingItemProps = {
  isDragging: boolean
  styles: ElementStyleCss<TestRankingSchemaType>
  font: ElementFontCss<TestRankingFontSchemaType>
  children: React.ReactNode
  index: number
  label?: string
  dragHandleProps?: DraggableProvidedDragHandleProps | null
}

const TestRankingItem = ({
  isDragging,
  styles,
  children,
  index,
  label,
  font,
  dragHandleProps,
}: TestRankingItemProps) => {
  return (
    <TestRankingItemStyled
      {...dragHandleProps}
      $isDragging={isDragging}
      $styles={styles}
      aria-label={!label?.trim() ? `Item ${index + 1}` : undefined}
    >
      <div
        className={s.icon}
        {...testProps({ el: 'courseRankingDrag', index })}
        style={{ color: font?.base.color }}
      >
        <Icon name='otherBurger' size={KitSize.M} aria-hidden />
      </div>
      {children}
    </TestRankingItemStyled>
  )
}

export default TestRankingItem
